import IMG_PLACEHOLDER_FRONT from        'assets/img/fast-sell/image-placeholders/front.jpg'
import IMG_PLACEHOLDER_RIGHT from        'assets/img/fast-sell/image-placeholders/right.jpg'
import IMG_PLACEHOLDER_LEFT from         'assets/img/fast-sell/image-placeholders/left.jpg'
import IMG_PLACEHOLDER_BACK from         'assets/img/fast-sell/image-placeholders/back.jpg'
import IMG_PLACEHOLDER_UNDER from        'assets/img/fast-sell/image-placeholders/under.jpg'
import IMG_PLACEHOLDER_INSIDE from       'assets/img/fast-sell/image-placeholders/inside.jpg'
import IMG_PLACEHOLDER_LABEL from        'assets/img/fast-sell/image-placeholders/label.jpg'
import IMG_PLACEHOLDER_MADE_IN_TAG from  'assets/img/fast-sell/image-placeholders/made-in-tag.jpg'
import IMG_PLACEHOLDER_SERIAL_CODE from  'assets/img/fast-sell/image-placeholders/serial.jpg'
import IMG_PLACEHOLDER_DEFECT from       'assets/img/fast-sell/image-placeholders/defect.jpg'


// Mapping of angle enum values to display labels
export const ANGLE_LABELS = {
  front       : 'bagian utama',
  right       : 'tampak kanan',
  left        : 'tampak kiri',
  back        : 'bagian belakang',
  under       : 'bagian bawah',
  inside      : 'bagian dalam',
  label       : 'logo/label merk',
  made_in_tag : 'made in tag',
  serial_code : 'nomor seri/kode tanggal',
  defect      : 'defect/lecet/rusak'
}

export const ANGLE_PLACEHOLDER_IMAGES = {
  front       : IMG_PLACEHOLDER_FRONT,
  right       : IMG_PLACEHOLDER_RIGHT,
  left        : IMG_PLACEHOLDER_LEFT,
  back        : IMG_PLACEHOLDER_BACK,
  under       : IMG_PLACEHOLDER_UNDER,
  inside      : IMG_PLACEHOLDER_INSIDE,
  label       : IMG_PLACEHOLDER_LABEL,
  made_in_tag : IMG_PLACEHOLDER_MADE_IN_TAG,
  serial_code : IMG_PLACEHOLDER_SERIAL_CODE,
  defect      : IMG_PLACEHOLDER_DEFECT
}

export const ANGLES = [
  {
    id    : 1,
    value : 'front',
    label : 'depan',
    order : 1
  },
  {
    id    : 2,
    value : 'left',
    label : '45° menghadap kanan',
    order : 2
  },
  {
    id    : 3,
    value : 'right',
    label : '45° menghadap kiri',
    order : 3
  },
  {
    id    : 4,
    value : 'back',
    label : 'belakang',
    order : 4
  },
  {
    id    : 5,
    value : 'under',
    label : 'bawah',
    order : 5
  },
  {
    id    : 6,
    value : 'inside',
    label : 'dalam',
    order : 6
  },
  {
    id    : 7,
    value : 'label',
    label : 'logo/label merk',
    order : 7
  },
  {
    id    : 8,
    value : 'made_in_tag',
    label : 'Made In Tag',
    order : 8
  },
  {
    id    : 9,
    value : 'serial_code',
    label : 'nomor seri/kode tanggal',
    order : 9
  },
  {
    id    : 10,
    value : 'defect',
    label : 'defect / lecet / rusak',
    order : 10
  }
]
